/*eslint-disable*/
import React, { useState, useEffect } from 'react';
import { SmallButton } from 'pg-ui-library';
import { useActions } from 'src/hooks/useActions';
import { useTypedSelector } from 'src/hooks/useTypedSelector';
import { IEmployeeAuditable } from 'src/interfaces';
import { DefaultTable } from 'src/components';
import { SortOrder, TableColumn } from 'react-data-table-component';

const columns = [
  {
    name: 'Report Suspicious Activity',
    cell: () => <SmallButton> Report </SmallButton>,
  },
  {
    name: 'IP Address',
    selector: (row: any) => row.ip,
    sortable: true,
    sortField: 'id',
  },
  {
    name: 'Attempt Time (ET)',
    sortable: true,
    sortField: 'attemptTime',
    selector: (row: any) => row.attemptTime,
  },
  {
    name: 'Access Type',
    selector: (row: any) => row.accessType,
  },
  {
    name: 'Correct Credentials',
    selector: (row: any) => row.correctCredentials,
  },
];

export const EmployeeAccessAttemptsTable: React.FC = () => {
  const { selectedEmployee } = useTypedSelector(state => state.employees.data);

  const { loadingAuditable } = useTypedSelector(state => state.employees.data.selectedEmployee);
  const { config } = useTypedSelector(state => state.config.data);
  const { getEmployeeAuditable } = useActions();

  const [data, setData] = useState<IEmployeeAuditable[]>([]);
  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [sortBy, setSortBy] = useState('attemptTime');
  const [sortDirection, setSortDirection] = useState('DESC');

  useEffect(() => {
    setData(selectedEmployee.auditable || []);
    setTotalRows(selectedEmployee.totalAuditable || 0);
  }, [selectedEmployee.auditable]);

  const handlePageChange = (page: number) => {
    setPage(page);
  };

  const handlePerRowsChange = async (newLimit: number, page: number) => {
    setLimit(newLimit);
  };

  const handleSort = async (column: TableColumn<any>, newSortDirection: SortOrder) => {
    setSortBy(column.sortField as unknown as string);
    setSortDirection(newSortDirection);
  };

  useEffect(() => {
    getEmployeeAuditable({
      page: page,
      companyId: config?.selectedCompanyId || '',
      limit: limit,
      employeeId: selectedEmployee.employee?.id || '',
      sortBy: sortBy,
      sortDirection: sortDirection,
    });
  }, [page, limit, sortBy, sortDirection]);

  return (
    <DefaultTable
      columns={columns}
      data={data}
      progressPending={loadingAuditable}
      pagination
      paginationServer
      paginationTotalRows={totalRows}
      onChangeRowsPerPage={handlePerRowsChange}
      onChangePage={handlePageChange}
      onSort={handleSort}
      sortServer
    />
  );
};
